import React from 'react';
import './OurIdentity.css';
import blackGoldLogo from "../../../../assets/images/Black Gold.png";
import siddharthLogo from "../../../../assets/images/SiddharthFashion.png";
import sheetalLogo from "../../../../assets/images/sheetal fashion 1.png";

const OurIdentity = () => {
  return (
    <section className="identity-section">
      <div className="identity-container">
        
        {/* Left Side: Logo Area (Smaller Width) */}
        <div className="identity-left">
          <h2 className="identity-title">OUR IDENTITY</h2>
          
          <div className="logo-grid">
            <div className="logo-wrapper">
              <div className="logo-card small-card">
                <img src={siddharthLogo} alt="Siddharth Fashion" />
              </div>
              <div className="logo-card small-card">
                <img src={sheetalLogo} alt="Sheetal Fashion" />
              </div>
              <div className="logo-card wide-card">
                <img src={blackGoldLogo} alt="Yug Mantra" />
              </div>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="identity-right">
          <div className="content-box">
            <p className="description-text">
              Every collection, every design, and every customer experience is backed 
              by the same commitment to quality, style, and service that our 
              customers have trusted for years.
            </p>
            
            <p className="tagline-text">
              Different Brands. Same Heritage. Same Trust.
            </p>
            
            <h3 className="slogan-text">
              Three names, <br />
              one trusted destination.
            </h3>
          </div>
        </div>

      </div>
    </section>
  );
};

export default OurIdentity;
